interface ChecklistItemBlockProps {
  criterion: string;
  status: "pass" | "fail" | "partial" | "pending";
  finding: string;
}

const STATUS_CONFIG = {
  pass: {
    icon: "✓",
    label: "Pass",
    classes: "bg-green-50 border-green-200 text-green-700",
    iconClass: "text-green-600",
  },
  fail: {
    icon: "✗",
    label: "Fail",
    classes: "bg-red-50 border-red-200 text-red-700",
    iconClass: "text-red-600",
  },
  partial: {
    icon: "~",
    label: "Partial",
    classes: "bg-amber-50 border-amber-200 text-amber-700",
    iconClass: "text-amber-600",
  },
  pending: {
    icon: "○",
    label: "Pending",
    classes: "bg-gray-50 border-gray-200 text-gray-600",
    iconClass: "text-gray-500",
  },
} as const;

export function ChecklistItemBlock({
  criterion,
  status,
  finding,
}: ChecklistItemBlockProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.pending;

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border p-3 ${config.classes}`}
    >
      <span
        className={`mt-0.5 flex-shrink-0 text-base font-bold ${config.iconClass}`}
        aria-label={config.label}
      >
        {config.icon}
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold leading-snug">{criterion}</p>
        <p className="mt-0.5 text-sm leading-relaxed opacity-80">{finding}</p>
      </div>
      <span className="flex-shrink-0 rounded px-1.5 py-0.5 text-xs font-medium uppercase tracking-wide opacity-70">
        {config.label}
      </span>
    </div>
  );
}
